import React from "react";
import {
  Container,
  Column,
  Img,
  Link,
  Row,
  Section,
  Text,
  Tailwind,
} from "@react-email/components";
import withClipboard from "@/shared/copy-to-clipboard";
import SocialLinks from "./social-links";
import { useSelector } from "react-redux";
import { selectUser } from "store/src/slices/auth-slice";

const EmailSignature3 = ({ id }) => {
  const user = useSelector(selectUser);

  return (
    <div id={id} className="bg-white p-4  rounded-sm">
      <Tailwind>
        <Container
          align="none"
          className="font-mono font-semibold w-72   border  border-gray-400 border-solid"
        >
          <Section className="">
            <Row>
              <Column>
                <Section>
                  <Row>
                    <Column className="py-4 px-4 text-center">
                      <Link
                        href={`https://7span.com/?utm_source=email&utm_medium=sign&utm_emp=${
                          user.email.split("@")[0]
                        }`}
                      >
                        <Img
                          className="h-12 inline-block m-0 ml-1 mt-1"
                          src="https://products.7span.in/assets/b950e28d-baa7-4b06-8293-2b82ec9ce853?cache-buster=2024-11-11T05:21:11.000Z&key=system-large-contain"
                        />
                      </Link>
                    </Column>
                  </Row>
                </Section>
              </Column>
              <Column className="border-0 border-l border-gray-400 border-solid">
                <Section>
                  <Row>
                    <Column className="border-0  border-solid  p-3">
                      <Text className="text-base leading-none m-0 text-black">
                        {user.first_name} {user.last_name}
                      </Text>
                      <Text className="text-xs m-0 mt-1 text-black">
                        {user.secondary_job_title || user.job_title?.name}
                      </Text>
                    </Column>
                  </Row>
                  <Row>
                    <SocialLinks user={user} />
                  </Row>
                </Section>
              </Column>
            </Row>
          </Section>
        </Container>
      </Tailwind>
    </div>
  );
};

export default withClipboard(EmailSignature3);
